// UV COORDINATES
export default {
    FLOORS: {
        FIRST_FLOOR: {
            y: 0.61,
        },
        GROUND_FLOOR: {
            y: 1,
        },
    },
    DOORS: {
        ML_OFFICE: {
            x: 0.03,
        },
    },
};
